<template>
  <div class="sidebar-inner">
    <router-link class="brand" :class="{ 'is-collapse': !sidebar.opened }" to="/home">
      <span v-if="sidebar.opened" class="brand__title">千朵云管理系统</span>
      <span v-else class="brand__short">千</span>
    </router-link>
    <scroll-bar>
      <el-menu
        mode="vertical"
        unique-opened
        :show-timeout="200"
        :default-active="$route.path"
        :collapse="isCollapse"
        background-color="#0b1220"
        text-color="#94a3b8"
        active-text-color="#ffffff"
      > 
        <sidebar-item :routes="routes"></sidebar-item>
      </el-menu>
    </scroll-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
} 
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.sidebar-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.brand {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 64px;
  padding: 0 16px;
  overflow: hidden;
  color: #fff;
  text-decoration: none;
  border-bottom: 1px solid rgba(148, 163, 184, 0.12);

  &.is-collapse {
    padding: 0 8px;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.04em;
    white-space: nowrap;
    line-height: 1.2;
    text-align: center;
  }

  &__short {
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: rgba(37, 99, 235, 0.22);
    font-size: 15px;
    font-weight: 700;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue